import { Button } from "@bandit-network/react-ui-kit";
import {
  CheckCircledIcon,
  ExternalLinkIcon,
  ReloadIcon,
} from "@radix-ui/react-icons";
import React, { useCallback, useState } from "react";
import { useQuestContext } from "../../../context/QuestContext";
import { Task, TaskType } from "../../../types";
import { getTarget, getUrl } from "../../../utils";
import { useConnect } from "@bandit-network/react-wallet-kit";
import { replaceHyperlinks } from "../../../utils/hyperlink";

export interface WebsiteProps {
  data: Task;
}

const Website: React.FC<WebsiteProps> = ({ data }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [counter, setCounter] = useState(1);
  const { tasksCompleted, questSDK } = useQuestContext();

  const { signature, address } = useConnect();

  const isTaskComplete = tasksCompleted.includes(data?.id);

  const visit = useCallback(async () => {
    let counterInterval;
    try {
      setIsLoading(true);

      await questSDK.saveWebsiteViewForQuest({
        walletAddress: address,
        signature: signature.data,
        taskId: data?.id,
      });
      setCounter(10);
      setTimeout(() => {
        window.open(data?.args?.websiteLink, getTarget());
      }, 500);
      counterInterval = setInterval(() => {
        setCounter((c) => c - 1);
      }, 1000);
    } catch (error) {
    } finally {
      setTimeout(() => {
        setIsLoading(false);
        clearInterval(counterInterval);
        setCounter(1);
      }, 10000);
    }
  }, [data, signature, address]);

  return (
    <div className="bad-quest__task">
      <p className="bad-quest__task--description">
        {replaceHyperlinks(data.description)}
      </p>
      <Button
        size="sm"
        className="bad-quest__task--action_button"
        onClick={visit}
        disabled={isLoading || isTaskComplete}
      >
        {isTaskComplete
          ? `Completed`
          : counter !== 1
            ? `Verify in ${counter}`
            : `Website`}
        {isLoading ? (
          <ReloadIcon className="bad-quest__task--reload_icon" />
        ) : isTaskComplete ? (
          <CheckCircledIcon className="bad-quest__task--check_icon" />
        ) : (
          <ExternalLinkIcon className="bad-quest__task--link_icon" />
        )}
      </Button>
    </div>
  );
};

export { Website };
